import Layout from '@/components/layout/Layout.vue'
import { getAdvertiserCosts } from '@/api/advertiser'
import SyncCostForm from '@/views/sys/advertiser/sync-cost/SyncCost.vue'
import FillCostForm from '@/views/sys/advertiser/fill-cost/FillCost.vue'

export default {
    components: {
        Layout,
        SyncCostForm,
        FillCostForm,
    },
    props: {
        showCostForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            columns: [
                { title: '日期', dataIndex: 'day' },
                { title: '消耗金额', dataIndex: 'cost' },
                { title: '更新时间', dataIndex: 'updated_at' },
            ],
            queryParam: {},
            modelSync: {},
            modelFill: {},
            showSyncCostForm: false,
            showFillCostForm: false,
            isFillCost: false,
        }
    },
    mounted() {
        if (this.model.media == 3 && this.model.sync_cost == false && this.model.account_id == 10) {
            this.isFillCost = true
        }
        this.getData()
    },
    methods: {
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                id: this.model.id,
            })
            this.$helper.buildDateRangeParams(json, 'date')
            getAdvertiserCosts(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        close() {
            this.$emit('update:showCostForm', false)
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('AdvertiserController', route)
        },
        syncCost() {
            this.modelSync = { ids: [this.model.id], is_fix: 1, day: null, }
            this.showSyncCostForm = true
        },
        fillCost() {
            this.modelFill = { id: this.model.id}
            this.showFillCostForm = true
        },

    }
}
